export const PropertyNotesTab = ({propertyDocument}) => {
    return (

        <div className="tab-pane fade" id="nav-pills-tab-notes">
            <h3 className="mt-10px">Notes</h3>
            <div className="col-xl-6" key={"Notes"}>
                <p>
                    # TODO: Add Notes UI
                </p>
            </div>
        </div>

    );
}